import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLazyGetPackingStyleDistributionQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const COLORS = ["#3D5673", "#5D733C", "#FFB14E", "#A192FA", "#F2C94C"];

export default function PackingStyleDistributionPacking() {
    const [trigger, { isLoading, error }] = useLazyGetPackingStyleDistributionQuery();
    const [chartData, setChartData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        if (!hasFetched) {
            setHasFetched(true);
            trigger()
                .unwrap()
                .then((response) => {
                    if (response?.success) {
                        // if (!toast.isActive("success-toast")) {
                        //     toast.success("Data fetched successfully!", {
                        //         toastId: "success-toast",
                        //     });
                        // }
                        const formattedData =
                            response?.data?.map((item, index) => ({
                                name:
                                    item.label &&
                                    item.label.charAt(0).toUpperCase() + item.label.slice(1).toLowerCase(),
                                value: item.value,
                                color: COLORS[index % COLORS.length], // Assign colors dynamically
                            })) || [];
                        setChartData(formattedData);
                    }
                })
                .catch(() => {
                    if (!toast.isActive("error-toast")) {
                        toast.error("Unable to fetch data. Please check your connection.", {
                            toastId: "error-toast",
                        });
                    }
                });
        }
    }, [trigger, hasFetched]);

    if (isLoading) {
        return <LoaderSpiner />;
    }

    if (error) {
        return <p>Error loading data. Please try again later.</p>;
    }

    return (
        <div className="h-[320px] relative">
            {/* Bar Chart Section */}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 10, right: 0, left: -30, bottom: 20 }}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        horizontal={true}
                        vertical={true}
                        stroke="#333333"
                    />
                    <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                    <YAxis />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#F1F1F1',
                            color: '#333',
                            borderRadius: '8px',
                            padding: '8px',
                            fontSize: '14px',
                        }}
                        labelStyle={{
                            fontWeight: 'bold',
                            fontSize: '14px',
                        }}
                        formatter={(value, name) => [`${value}`, `${name}`]}
                    />
                    <Bar dataKey="value"
                        fill="#FEEE91"
                        radius={[4, 4, 0, 0]}
                    >
                        {/* {chartData.map((entry, index) => (
                            <rect key={`bar-${index}`} fill={entry.color} />
                        ))} */}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {/* Legend Section */}
            {/* <div className="flex justify-center flex-col mt-2 font-['Quicksand'] text-sm font-medium">
                {chartData.map((entry, index) => (
                    <div key={entry.name} className="flex items-center justify-center w-full gap-2">
                        <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: entry.color }}></div>
                        <span className="md:text-sm text-xs">{entry.name}</span>
                    </div>
                ))}
            </div> */}
        </div>
    );
}
